import React, { useState, useEffect } from "react";
import "./Navbar.css";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const toggleMenu = () => setIsMenuOpen((v) => !v);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsScrolled(scrollPosition > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Navbar is transparent when not scrolled, solid when scrolled (works for all routes)
  const navbarClasses = `fp-navbar ${!isScrolled ? "transparent" : "solid"}`;

  return (
    <header className={navbarClasses} id="navbar">
      <div className="fp-navbar__inner">
        {/* Left: Logo */}
        <a href="/" className="fp-navbar__brand" aria-label="Community Impact Solutions">
          <img
            src="./logoo.png"
            alt="Community Impact Solutions logo"
            className="fp-navbar__logo"
          />
        </a>

        {/* Desktop Menu */}
        <nav className="fp-navbar__nav" aria-label="Primary">
          <ul className="fp-navbar__menu">
            <li><a className="fp-navbar__link" href="/">Home</a></li>
            <li><a className="fp-navbar__link" href="/about-us">About Us</a></li>
            <li><a className="fp-navbar__link" href="/services">Services</a></li>
            <li><a className="fp-navbar__link" href="/contact">Contact</a></li>
          </ul>
        </nav>

        {/* Hamburger */}
        <div className="fp-navbar__cta">
          <button
            className={`fp-navbar__hamburger ${isMenuOpen ? "open" : ""}`}
            onClick={toggleMenu}
            aria-label="Menu"
            aria-expanded={isMenuOpen}
          >
            <span className="fp-navbar__hamburger-line"></span>
            <span className="fp-navbar__hamburger-line"></span>
            <span className="fp-navbar__hamburger-line"></span>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div className={`fp-navbar__mobile-menu ${isMenuOpen ? "open" : ""}`}>
        <ul className="fp-navbar__mobile-menu-list">
          <li><a className="fp-navbar__mobile-link" href="/" onClick={toggleMenu}>Home</a></li>
          <li><a className="fp-navbar__mobile-link" href="/about-us" onClick={toggleMenu}>About Us</a></li>
          <li><a className="fp-navbar__mobile-link" href="/services" onClick={toggleMenu}>Services</a></li>
          <li><a className="fp-navbar__mobile-link" href="/contact" onClick={toggleMenu}>Contact</a></li>
        </ul>
      </div>
    </header>
  );
};

export default Navbar;